import { render, staticRenderFns } from "./PlantGantt.vue?vue&type=template&id=fd2c0c90&scoped=true&"
import script from "./PlantGantt.vue?vue&type=script&lang=js&"
export * from "./PlantGantt.vue?vue&type=script&lang=js&"
import style0 from "./PlantGantt.vue?vue&type=style&index=0&id=fd2c0c90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd2c0c90",
  null
  
)

export default component.exports